import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function ContentPreview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = ['https://cdn.magicpatterns.com/uploads/68Gi7YjjFmyiwobydfqPif/Screenshot_2026-06-05_at_11.19.24_PM.png', 'https://cdn.magicpatterns.com/uploads/gWQF9QRLC75K3dN6GXeM7Y/Screenshot_2026-06-05_at_11.19.05_PM.png', 'https://cdn.magicpatterns.com/uploads/9KSKqZiWi61d83mGfJGyBN/Screenshot_2026-06-05_at_11.18.42_PM.png'];
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const nextImage = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  const prevImage = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  return <section className="w-full px-4 py-12 bg-white" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-65">
          Un vistazo del contenido 👀
        </h2>

        <div className="relative max-w-2xl mx-auto" data-id="element-66">
          <div className="relative aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden shadow-xl cursor-pointer" onClick={scrollToPurchase} data-id="element-67">
            <img src={images[currentIndex]} alt={`Contenido ${currentIndex + 1}`} className="w-full h-full object-contain" data-id="element-68" />
          </div>

          <button onClick={prevImage} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-colors" aria-label="Anterior" data-id="element-69">
            <ChevronLeftIcon className="w-6 h-6 text-gray-800" data-id="element-70" />
          </button>

          <button onClick={nextImage} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-colors" aria-label="Siguiente" data-id="element-71">
            <ChevronRightIcon className="w-6 h-6 text-gray-800" data-id="element-72" />
          </button>

          <div className="flex justify-center gap-2 mt-4" data-id="element-73">
            {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-colors ${index === currentIndex ? 'bg-green-600' : 'bg-gray-300'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-74" />)}
          </div>
        </div>
      </div>
    </section>;
}